module.exports = __webpack_public_path__ + "assets/img/returnBtn-842aca6c.png";